module.exports = __webpack_public_path__ + "static/media/500010.ce6ff778.svg";